<template>
  <v-sheet class="d-flex" id="reponsibles-data-sheet">
    <v-card>
      <v-card-title>
        <h4>
          Responsables
          <small
            v-if="!$store.state.moduleApplications.currentApplication.application_data.responsibles.main && !$store.state.moduleApplications.currentApplication.application_data.responsibles.secondary"
          >
            <i>(Pas de données)</i>
          </small>
        </h4>
      </v-card-title>
      <v-divider></v-divider>
      <v-list dense>
        <div
          v-if="$store.state.moduleApplications.currentApplication.application_data.responsibles.main"
        >
          <v-subheader>Principal</v-subheader>
          <v-list-tile>
            <v-list-tile-content><b>Genre</b></v-list-tile-content>
            <v-list-tile-content
              class="align-end"
            >{{ $store.state.moduleApplications.currentApplication.application_data.responsibles.main.responsible_gender }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content><b>Nom, prénom</b></v-list-tile-content>
            <v-list-tile-content class="align-end">
              {{ $store.state.moduleApplications.currentApplication.application_data.responsibles.main.responsible_name }},
              {{ $store.state.moduleApplications.currentApplication.application_data.responsibles.main.responsible_fsname }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content><b>Adresse</b></v-list-tile-content>
            <v-list-tile-content class="align-end">
              {{ $store.state.moduleApplications.currentApplication.application_data.responsibles.main.responsible_street }},
              {{ $store.state.moduleApplications.currentApplication.application_data.responsibles.main.responsible_npa }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content><b>Téléphone</b></v-list-tile-content>
            <v-list-tile-content
              class="align-end"
            >{{ $store.state.moduleApplications.currentApplication.application_data.responsibles.main.responsible_phone }}</v-list-tile-content>
          </v-list-tile>
        </div>
        <v-divider></v-divider>
        <div
          v-if="$store.state.moduleApplications.currentApplication.application_data.responsibles.secondary"
        >
          <v-subheader>Secondaire</v-subheader>
          <v-list-tile>
            <v-list-tile-content><b>Genre</b></v-list-tile-content>
            <v-list-tile-content
              class="align-end"
            >{{ $store.state.moduleApplications.currentApplication.application_data.responsibles.secondary.responsible_gender }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content><b>Nom, prénom</b></v-list-tile-content>
            <v-list-tile-content class="align-end">
              {{ $store.state.moduleApplications.currentApplication.application_data.responsibles.secondary.responsible_name }},
              {{ $store.state.moduleApplications.currentApplication.application_data.responsibles.secondary.responsible_fsname }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content><b>Adresse</b></v-list-tile-content>
            <v-list-tile-content class="align-end">
              {{ $store.state.moduleApplications.currentApplication.application_data.responsibles.secondary.responsible_street }},
              {{ $store.state.moduleApplications.currentApplication.application_data.responsibles.secondary.responsible_npa }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content><b>Téléphone</b></v-list-tile-content>
            <v-list-tile-content
              class="align-end"
            >{{ $store.state.moduleApplications.currentApplication.application_data.responsibles.secondary.responsible_phone }}</v-list-tile-content>
          </v-list-tile>
        </div>
      </v-list>
    </v-card>
  </v-sheet>
</template>

<script>
export default {
  name: 'reponsibles-data-sheet'
}
</script>
